import { Typography } from "antd";
import React, { FC } from "react";
import { IJob } from "./helper";

interface Props {
  job?: IJob;
}
export const PageHeading: FC<Props> = ({ job }) => (
  <Typography.Title level={2}>{job?.positionTitle || "Hiring Manager's Dashboard"}</Typography.Title>
);

export default PageHeading;